/**
*
*   Collection List
*       - The Collection Data on the collection page
*
**/
'use client';

import SearchResults from '@/components/search/results';
import { useState, useRef } from 'react';
import { useSearchParams } from 'next/navigation';
import { useTranslations , useLocale } from 'next-intl';


//Build the Collection
export default function SearchPage({ data }){

	//Get the URL params (if they exist)
	const params = useSearchParams();

	const l = useLocale();

	//Translations
	const t = useTranslations();

	//Search Results
	const [ search, setSearch ] = useState({
		loading:    false,
		query:      params.get('q') ?? ''
	});

	//The Search element
	const $el = useRef();

	//The Query Input Field
	const $input = useRef();

	//The Search Controller
	const Controller = {

		//
		intval: false,

		/**
		*
		*   change
		*       - Changes the Query State
		*
		*   Params
		*       n/a
		*
		**/
		change: e => {
			setSearch({
				...search,
				query: e.target.value
			});
		},

		/**
		*
		*   execute
		*       - Runs the Search
		*
		*   Params
		*       n/a
		*
		**/
		execute: async () => {

			//Skip if it's already run
			if(search.loading)
				return false;

			//Set as Loading
			setSearch({
				...search,
				loading: true
			});

			//Set the Timeout
			window.setTimeout(()=>{

				//Set as Loading
				setSearch({
					...search,
					loading:  false,
					query:    $input.current.value
				});

			},500);

		}

	};

	return (
		<section id="search-page" className="container">

			<form action="/search" id="search-form">

				<input type="text" ref={ $input } onKeyUp={ Controller.execute } placeholder={ t('Pages.Search.Form.placeholder') } onChange={ e => Controller.change(e) } value={ search.query } />

				<button disabled={ search.loading } onClick={ Controller.execute }>
					<svg version="1.1" className="icon-search" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 34 33.9" style={{ enableBackground: 'new 0 0 34 33.9' }} xmlSpace="preserve">
						<circle cx="13.7" cy="13.8" r="12.6"/>
						<line x1="23" y1="22.9" x2="32.9" y2="32.7"/>
					</svg>
				</button>

			</form>

			<section id="search-results">
				<SearchResults search={ search } />
			</section>

		</section>
	);

}